module.exports = {"431226101":"锦和镇","431226102":"江口墟镇","431226103":"岩门镇","431226104":"兰里镇","431226105":"吕家坪镇","431226106":"高村镇","431226107":"尧市镇","431226108":"郭公坪镇","431226204":"文昌阁乡","431226205":"大桥江乡","431226206":"舒家村乡","431226207":"隆家堡乡","431226208":"谭家寨乡","431226209":"石羊哨乡","431226210":"板栗树乡","431226212":"兰村乡","431226215":"和平溪乡","431226216":"黄桑乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431226.json
// module id = 1755
// module chunks = 0